import styled from '@emotion/styled'
import { Box, Grid, Skeleton, Typography } from '@mui/material'
import Card from '@mui/material/Card'
import { Link } from 'react-router-dom'
import StyledP from 'shared/components/StyledP'
import { getPxAsRem } from 'shared/utils'

export const GridContainer = styled(Grid)`
    padding-top: ${getPxAsRem(16)};
`

export const StyledCard = styled(Card)`
    background: ${({ theme }) => theme.palette.greyscale.white};
    border: 1px solid ${({ theme }) => theme.palette.greyscale.grey_100};
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: ${getPxAsRem(416)};
    gap: ${getPxAsRem(12)};
    padding: ${getPxAsRem(24)};
    cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};

    &:focus-visible {
        outline: 1px solid ${({ theme }) => theme.palette.primary.main};
    }

    @media (max-width: 1124px) {
        min-height: ${getPxAsRem(416)};
    }

    @media (max-width: 945px) {
        min-height: ${getPxAsRem(440)};
    }
`

export const StyledCardTitle = styled(StyledP)`
    font-size: 1.25rem;
    font-weight: 600;
    line-height: 1.2;
    margin-bottom: 1.5rem;
    text-align: left;
`

export const StyledTitle = styled(StyledP)`
    font-size: 3rem;
    line-height: 1.2;
    margin-bottom: ${getPxAsRem(10)};
    text-align: left;
`

export const StyledLink = styled(Link)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${getPxAsRem(16, 0)};
    border-bottom: 1px solid ${({ theme }) => theme.palette.greyscale.grey_100};
    color: ${({ theme }) => theme.palette.greyscale.black};
    text-decoration: none;

    &:last-of-type {
        border-bottom: none;
    }
`

export const ScheduleContainer = styled.div`
    max-height: ${getPxAsRem(250)};
    overflow-y: auto;
    gap: ${getPxAsRem(4)};
`

export const EmptyStateContainer = styled(Box)`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: ${getPxAsRem(16)};
    margin: auto;
    padding-bottom: ${getPxAsRem(36)};
    text-align: center;
`

export const ScheduleDetailsContainer = styled.div`
    align-items: center;
    display: flex;
    gap: ${getPxAsRem(4)};
    color: ${({ theme }) => theme.palette.greyscale.grey_600};
`

export const BulletPoint = styled(Box)`
    display: inline-block;
    transform: scale(0.8);
`

export const BoxWithBorder = styled(Box)`
    border-color: rgba(0, 0, 0, 0.12);
    width: 100%;
    height: 100%;
    color: rgba(0, 0, 0, 0.6);
    padding-bottom: ${getPxAsRem(14)};
    border-bottom: 1px solid;
    margin-top: ${getPxAsRem(14)};
`

export const BoxWithOutBorder = styled(Box)`
    border-color: rgba(0, 0, 0, 0.12);
    width: 100%;
    height: 100%;
    color: rgba(0, 0, 0, 0.6);
    padding-bottom: ${getPxAsRem(14)};
    margin-top: ${getPxAsRem(14)};
`

export const GridText = styled(Grid)`
    text-align: 'right';
`

export const Container = styled(Grid)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 100%;
`

export const DashboardCardRow = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: ${getPxAsRem(52)};
`

export const DashboardCardSkeleton = styled(Skeleton)`
    padding: ${getPxAsRem(14, 0)};
`

export const DashboardCardRowTitle = styled(Typography)`
    margin-right: auto;
    padding-right: ${getPxAsRem(16)};
    white-space: nowrap;
`
